import styles from './cheating.module.css';
import FullSize from '../../components/full-size';

function Cheating() {
  return (
    <FullSize bgColor="#ED2939">
      <div className={styles.cheating_wrapper}>
        <h1 className={styles.title}>FUSK</h1>
        <p className={styles.text}>Skäms på dig.</p>
      </div>
    </FullSize>
  );
}

export default Cheating;
